import { IBusiness } from '@/store/modules/managerTypes';

export interface ICustomerImportOverview {
  importedAt: null | string;
  importedCustomers: number;
  loyaltyProgramCustomers: number;
  enrollmentRate: string;
}

export interface ICampaignSummary {
  totalRedeemedCoins: string;
  convertedCustomers: string;
  convertionRate: string;
  coinsPerCustomer: string;
}

export interface ICampaignStatistics {
  label: string;
  value: string;
  tooltip: string;
}

export interface ICustomerImportSummaryAndStatistics {
  campaignCreatedAt: null | string;
  summary: ICampaignSummary;
  statistics: ICampaignStatistics[];
}

export enum ECustomerImportCampaignStatus {
  COMPLETED = 'complete',
  PENDING = 'pending',
  SKIPPED = 'skipped',
  DROPPED = 'dropped'
}

export enum ECustomerLeadListFilterAlias {
  INVITATION_SENT = 'invitation-sent',
  EMAILS_OPENED = 'emails-opened',
  LINKS_CLICKED = 'links-clicked',
  LOYALTY_CUSTOMERS = 'loyalty-customers',
  PENDING_CUSTOMERS = 'pending-customers',
  EMAILS_NOT_SENT = 'emails-not-sent'
}

export interface ICustomerImport {
  id?: string;
  importedAt: string;
  email: string;
  firstName?: string;
  lastName?: string;
  name: string;
  sent: ECustomerImportCampaignStatus;
  opened: ECustomerImportCampaignStatus;
  clicked: ECustomerImportCampaignStatus;
  registered: ECustomerImportCampaignStatus;
}

export interface ICustomerImportPagination<T = any> {
  items: Array<T>;
  total: number;
  itemsTotal: number;
  links: {
    next: string | null;
  };
}

export enum ECustomerImportProgressStatus {
  QUEUED = 'queued',
  PENDING = 'pending',
  IMPORT_NOT_REQUESTED = 'importNotRequested',
  IMPORTING = 'importing',
  FAILED = 'failed',
  SUCCESS = 'success',
  DONE = 'done'
}

export interface ICustomerImportStatus {
  success: boolean;
  status: ECustomerImportProgressStatus;
  current: number;
  total: number;
  failedTimes: number;
  message: string;
  clickedGetStarted: boolean;
}

export interface ICustomerImportCampaign {
  id: string;
  createdAt: string;
  updatedAt: string;
  coinsReward: string;
  status: string;
  link: string;
  automaticInvites: boolean;
  automaticReminders: boolean;
  business: IBusiness;
  eligibleCustomerAmount: number;
  totalCustomers: number;
}

export interface ICustomerImportChangeCampaignData {
  payload: {
    flag: string;
    value: boolean;
  };
  campaignId: string;
}

export interface ICustomerImportElegibleCustomersResponse {
  eligibleCustomerAmount: number;
}

export interface ICustomerImportCreateCampaignData {
  payload: {
    coinsReward: number;
  };
  providerName: string;
}

export interface ICustomerImportGetCampaignData {
  campaignId: string;
}
